import { useSyncExternalStore } from "react";

/**
 * Shared wall-clock used by time-derived UI (like the late-visit cue). One
 * interval drives every subscriber rather than one timer per component, so a
 * rail of many cards costs a single tick. The interval only runs while at least
 * one component is mounted.
 */
const TICK_MS = 30_000;

let now = Date.now();
let intervalId: ReturnType<typeof setInterval> | null = null;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  if (intervalId === null) {
    now = Date.now();
    intervalId = setInterval(() => {
      now = Date.now();
      listeners.forEach((l) => l());
    }, TICK_MS);
  }
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };
};

/** Current time in ms, re-read every 30s so idle pages still advance. */
export const useNow = (): number => useSyncExternalStore(subscribe, () => now);
